"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const SidebarBadge = ({ children }) => {
    return ((0, jsx_runtime_1.jsx)("span", { className: "_bg-blue _text-1 _text-white _rounded _px-2 _py-1 _ml-2 _font-weight-bold", children: children }));
};
exports.default = SidebarBadge;
